import React from 'react';
import { Routes, Route } from 'react-router-dom';
import './App.css';
import AppHome from './components/AppHome/AppHome.component';
import NavPanel from './components/NavPanel/NavPanel.component';
import Navigation from './routes/navigation/navigation.component';
import Authentication from './routes/authentication/authentication.component';
import SignOut from './components/SignOut/SignOut.component';

const App = () => {


  return (
    <Routes>
      <Route path='/' element={<Navigation /> }>
        <Route path='home' element={<AppHome />}/>
        <Route path='auth' element={<Authentication />}/>
        <Route path='view' element={<NavPanel />}/>
        <Route path='exit' element={<SignOut />}/>
      </Route>
    </Routes>
  );
}

export default App;
